import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function ObservacoesDiagnostico() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção permite registrar observações gerais e um diagnóstico preliminar sobre a infraestrutura econômica e urbana do município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="pontos_fortes"
          label="Principais pontos fortes"
          type="textarea"
          placeholder="Descreva os principais pontos fortes da infraestrutura econômica e urbana"
          helpText="Aspectos positivos que se destacam na infraestrutura local"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>
      
      <div className="mt-4">
        <FormField
          name="desafios_principais"
          label="Principais desafios"
          type="textarea"
          placeholder="Descreva os principais desafios da infraestrutura econômica e urbana"
          helpText="Principais problemas e obstáculos identificados"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>
      
      <div className="mt-4">
        <FormField
          name="sugestoes_politicas"
          label="Sugestões de políticas públicas"
          type="textarea"
          placeholder="Descreva sugestões de políticas públicas para melhorar a infraestrutura"
          helpText="Propostas de intervenções e políticas para enfrentar os desafios identificados"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao10"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao10"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
